import { createContext, useContext, useState } from 'react'

import { TicketChatMessageWithKey } from '@/modules/tickets/modules/ticketChat/domain/models/TicketChatMessages'

const ticketChatContext = createContext<{
  currentChatRoomId: string
  setCurrentChatRoomId: React.Dispatch<React.SetStateAction<string>>
  chosenReply: TicketChatMessageWithKey | undefined
  setChosenReply: (message: TicketChatMessageWithKey) => void
  clearChosenReply: () => void
  isReplyMessageSender: boolean
  setIsReplyMessageSender: React.Dispatch<React.SetStateAction<boolean>>
}>({
  currentChatRoomId: '',
  setCurrentChatRoomId: () => {},
  chosenReply: undefined,
  setChosenReply: () => {},
  clearChosenReply: () => {},
  isReplyMessageSender: false,
  setIsReplyMessageSender: () => {}
})

export const useTicketChatContext = () => useContext(ticketChatContext)

export function TicketChatProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [currentChatRoomId, setCurrentChatRoomId] = useState('')
  const [chosenReply, setChosenReply] = useState<TicketChatMessageWithKey>()
  const [isReplyMessageSender, setIsReplyMessageSender] = useState(false)

  return (
    <ticketChatContext.Provider
      value={{
        currentChatRoomId,
        setCurrentChatRoomId,
        chosenReply,
        setChosenReply: (message: TicketChatMessageWithKey) =>
          setChosenReply(message),
        clearChosenReply: () => setChosenReply(undefined),
        isReplyMessageSender,
        setIsReplyMessageSender
      }}
    >
      {children}
    </ticketChatContext.Provider>
  )
}
